/**
 * PDP orderability + variant-kontekst: DOM fra `deriveOrderabilityView`, line-item hidden inputs,
 * medie/spec/plinth. On-sale picker styling: `product-pdp-variant-sale-ui.js` (ADR-002).
 * Kræver `product-storefront-domain.js` (HFCProductDomain) for kanonisk state.
 */
(function (global) {
    'use strict';

    function getProductVariants() {
        return (global.shopify_product && global.shopify_product.variants) || [];
    }

    function findVariantById(variant_id) {
        if (variant_id == null || variant_id === '') {
            return null;
        }
        return getProductVariants().find(function (variant) {
            return String(variant.id) === String(variant_id);
        }) || null;
    }

    function getSelectedVariantIdFromDom() {
        var id_input = document.querySelector('form.main-product-form input[name="id"]:not([disabled])')
            || document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]:not([disabled])')
            || document.querySelector('input[name="id"]:not([disabled])');
        if (id_input && id_input.value) {
            return id_input.value;
        }
        if (global._last_selected_variant_id != null) {
            return global._last_selected_variant_id;
        }
        return null;
    }

    function getCurrentVariant() {
        var variant_id = getSelectedVariantIdFromDom();
        if (variant_id == null) {
            variant_id = new URLSearchParams(global.location.search).get('variant');
        }
        if (variant_id == null && global.shopify_product && global.shopify_product.selected_or_first_available_variant) {
            variant_id = global.shopify_product.selected_or_first_available_variant.id;
        }
        return findVariantById(variant_id);
    }

    function getVariantOptionValue(variant, option_index) {
        if (!variant) {
            return null;
        }
        if (option_index === 0) {
            return variant.color;
        }
        if (option_index === 1) {
            return variant.surface;
        }
        if (option_index === 2) {
            return variant.size;
        }
        return null;
    }

    function resolveSelectedVariantFromPicker() {
        var variants = getProductVariants();
        var picker = document.querySelector('variant-picker');
        if (!variants.length || !picker) {
            return null;
        }
        var picker_fields = Array.from(picker.querySelectorAll('[data-picker-field]'));
        if (!picker_fields.length) {
            return null;
        }
        var selected_options = picker_fields.map(function (field) {
            var type = field.dataset.pickerField;
            if (type === 'radio') {
                var checked = field.querySelector('input:checked');
                return checked ? checked.value : null;
            }
            var select = field.querySelector('select');
            return select ? select.value : null;
        });
        return variants.find(function (variant) {
            return selected_options.every(function (selected_value, option_index) {
                if (selected_value == null || selected_value === '') {
                    return true;
                }
                return String(getVariantOptionValue(variant, option_index)) === String(selected_value);
            });
        }) || null;
    }

    function resolveSelectedVariant() {
        try {
            var by_id = findVariantById(getSelectedVariantIdFromDom());
            if (by_id) {
                return by_id;
            }
            var by_picker = resolveSelectedVariantFromPicker();
            if (by_picker) {
                return by_picker;
            }
            return getCurrentVariant();
        } catch (e) {
            return getCurrentVariant();
        }
    }

    global.HFCProductPdpVariants = {
        getProductVariants: getProductVariants,
        getCurrentVariant: getCurrentVariant,
        resolveSelectedVariant: resolveSelectedVariant,
        findVariantById: findVariantById,
    };

    global.get_product_variants = function () {
        return getProductVariants();
    };
    global.get_current_variant = function () {
        return getCurrentVariant();
    };
    global.resolve_selected_variant = function () {
        return resolveSelectedVariant();
    };

    function domHide(element) {
        if (!element || element.classList.contains('hidden')) {
            return;
        }
        element.style.display = 'none';
    }

    function domShow(element) {
        if (!element) {
            return;
        }
        element.classList.remove('hidden');
        element.removeAttribute('hidden');
        if (element.style.removeProperty) {
            element.style.removeProperty('display');
        } else {
            element.style.removeAttribute('display');
        }
    }

    function getOrderability(variant) {
        var product = global.shopify_product || {};
        var d = global.HFCProductDomain;
        if (d && typeof d.deriveOrderabilityView === 'function') {
            return d.deriveOrderabilityView(variant, product);
        }
        return resolveOrderabilityFallback(variant);
    }

    /**
     * TRANSITIONEL: Kun når HFCProductDomain mangler — ikke en anden regelmotor.
     */
    function resolveOrderabilityFallback(variant) {
        var product = global.shopify_product || {};
        var sampleOk = !!product.is_sample_orderable;
        if (!variant) {
            return {
                fulfillment_state: 'out_of_stock_non_backorderable',
                primary_state: 'unavailable',
                uses_m2_calculator: false,
                sample_orderable: sampleOk,
                sample_status: sampleOk ? 'sample_eligible' : 'none',
                sold_in_full_packs_only: false,
                has_low_stock_warning: false,
                special_order_inventory_branch: null,
                hide_standard_buy_buttons: true,
                show_backorder_info_static: false,
                unit_of_sale: 'per_piece',
                quantity_mode: 'standard',
                message_flags: {},
            };
        }
        if (typeof console !== 'undefined' && console.warn && !global.__hfcWarnedMissingProductDomain) {
            global.__hfcWarnedMissingProductDomain = true;
            console.warn('[HFC] HFCProductDomain mangler — PDP orderability er nedgraderet (købsknapper skjult).');
        }
        var usesM2 = false;
        try {
            var pm = variant.metafields && variant.metafields.pieces_per_square_meter;
            usesM2 = pm != null && pm !== '' && String(pm) !== '0' && String(pm) !== '0.0';
        } catch (e) { /* noop */ }
        return {
            fulfillment_state: 'out_of_stock_non_backorderable',
            primary_state: 'out_of_stock',
            uses_m2_calculator: usesM2,
            sample_orderable: sampleOk,
            sample_status: sampleOk ? 'sample_eligible' : 'none',
            sold_in_full_packs_only: false,
            has_low_stock_warning: false,
            special_order_inventory_branch: null,
            hide_standard_buy_buttons: true,
            show_backorder_info_static: false,
            unit_of_sale: 'per_piece',
            quantity_mode: usesM2 ? 'm2_calculator' : 'standard',
            message_flags: {},
        };
    }

    function variantUsesM2Calculator(variant) {
        if (!variant) {
            return false;
        }
        var d = global.HFCProductDomain;
        if (d && typeof d.deriveQuantityMode === 'function') {
            return d.deriveQuantityMode(variant) === 'm2_calculator';
        }
        var ob = getOrderability(variant);
        if (ob && typeof ob.uses_m2_calculator === 'boolean') {
            return ob.uses_m2_calculator;
        }
        var m = variant.metafields && variant.metafields.pieces_per_square_meter;
        return m != null && m !== '' && m !== 0 && m !== '0.0';
    }

    function syncOrderabilityRootAttrs(ob) {
        var root = document.querySelector('[data-pdp-orderability-root]');
        if (!root || !ob) {
            return;
        }
        if (ob.fulfillment_state) {
            root.setAttribute('data-fulfillment-state', ob.fulfillment_state);
        }
        root.setAttribute('data-primary-state', ob.primary_state);
        root.setAttribute('data-orderability-hide-buy', ob.hide_standard_buy_buttons ? 'true' : 'false');
        root.setAttribute('data-orderability-backorder-static', ob.show_backorder_info_static ? 'true' : 'false');
        root.setAttribute('data-orderability-uses-m2', ob.uses_m2_calculator ? 'true' : 'false');
    }

    function syncBackorderBlockVisibility(variant, ob, qtyInput) {
        var wrap = document.querySelector('#backorder-enabled-wrapper');
        var block = wrap && wrap.closest('.main-product__block');
        if (!block || !ob) {
            return;
        }
        if (!variant) {
            block.style.display = 'none';
            return;
        }
        if (ob.fulfillment_state === 'backorderable') {
            block.style.display = 'flex';
            return;
        }
        block.style.display = 'none';
    }

    function apply_tile_m2_layout_from_orderability(variant, ob) {
        if (!ob || !ob.uses_m2_calculator || !variant) {
            return;
        }
        var price_block = document.querySelector('.main-product__block.main-product__block-price');
        var calc_block = document.querySelector('.main-product__block.main-product__block-m2_price_calculator');
        var quantity_input_wrapper = document.querySelector('.quantity_and_buy_button_div div[data-quantity-input-wrapper]');
        var inventory_quantity = document.querySelector('#_custom-inventory-quantity');
        if (!calc_block) {
            return;
        }
        if (price_block) {
            domHide(price_block);
        }
        domShow(calc_block);
        if (quantity_input_wrapper) {
            domHide(quantity_input_wrapper);
        }
        if (inventory_quantity) {
            if (ob.fulfillment_state === 'special_order') {
                domHide(inventory_quantity);
            } else if (inventory_quantity.style.removeProperty) {
                inventory_quantity.style.removeProperty('display');
            } else {
                inventory_quantity.style.removeAttribute('display');
            }
        }
    }

    function update_inventory_info_from_variant(variant, ob) {
        if (!variant) {
            return;
        }
        var piece_per_price_span = document.querySelector('#_custom-piece-per-price');
        var orderable_item_text_tile = document.querySelector('#m2_price_calculator #_custom-orderable-item-text');
        var orderable_item_text_non_tile = document.querySelector('#_custom-price-wrapper #_custom-orderable-item-text');
        var inventory_quantity = document.querySelector('#_custom-inventory-quantity');
        var pieces_per_pack = document.querySelector('#pieces_per_pack_span');
        if (pieces_per_pack && variant.metafields) {
            pieces_per_pack.innerHTML = variant.metafields.pieces_per_pack;
        }
        if (inventory_quantity && variant.metafields && variant.metafields.is_procured !== true) {
            inventory_quantity.innerHTML = variant.inventory_quantity + ' tilbage på lager';
        }
        if (piece_per_price_span && variant.metafields) {
            if (variant.metafields.pieces_per_pack <= 1) {
                piece_per_price_span.innerHTML = 'Sælges pr. stk.';
            } else {
                piece_per_price_span.innerHTML = '';
            }
        }
        var procured = ob && ob.fulfillment_state === 'special_order';
        var soldPacks = ob && ob.sold_in_full_packs_only;
        var lineA = '';
        var lineB = '';
        if (procured) {
            lineA = soldPacks ? 'Bestillingsvare sælges kun i hele kasser' : 'Bestillingsvare sælges pr. stk.';
            lineB = lineA;
        }
        if (orderable_item_text_tile) {
            orderable_item_text_tile.innerHTML = lineA;
        }
        if (orderable_item_text_non_tile) {
            orderable_item_text_non_tile.innerHTML = lineB;
        }
    }

    function sync_selected_media_state(variant) {
        if (!variant) {
            return;
        }
        var mediaItems = document.querySelectorAll('.pdp-figma-media-grid .sf-prod-media-item');
        if (!mediaItems.length) {
            return;
        }
        var normalize = function (value) {
            return String(value || '').trim().toLowerCase();
        };
        var selectedColor = normalize(variant.color || variant.option1 || (Array.isArray(variant.options) ? variant.options[0] : ''));
        var selectedMediaId = variant.featured_media && variant.featured_media.id ? String(variant.featured_media.id) : '';
        var matchedByVariant = false;
        mediaItems.forEach(function (item) {
            var colors = String(item.dataset.variantColors || '')
                .split('|')
                .map(normalize)
                .filter(Boolean);
            var isVariantMatch = selectedColor && colors.includes(selectedColor);
            item.classList.toggle('is-selected', isVariantMatch);
            if (isVariantMatch) {
                matchedByVariant = true;
            }
        });
        if (!matchedByVariant && selectedMediaId) {
            mediaItems.forEach(function (item) {
                item.classList.toggle('is-selected', item.dataset.mediaId === selectedMediaId);
            });
        }
    }

    function syncHfcLinePropertyInputs(variant, ob) {
        var d = global.HFCProductDomain;
        var form = document.querySelector('form.main-product-form');
        if (!form || !d || !variant || !ob) {
            return;
        }
        form.querySelectorAll('input[data-hfc-line-prop]').forEach(function (el) {
            el.remove();
        });
        var props = d.buildLineItemProperties({
            fulfillment_state: ob.fulfillment_state,
        });
        Object.keys(props).forEach(function (key) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.setAttribute('data-hfc-line-prop', '1');
            input.name = 'properties[' + key + ']';
            input.value = props[key] == null ? '' : String(props[key]);
            form.appendChild(input);
        });
    }

    function parse_durability_label(raw) {
        var s = String(raw || '').trim();
        if (!s) {
            return null;
        }
        function level_from_digit_char(ch) {
            var n = parseInt(ch, 10);
            if (isNaN(n) || n < 1 || n > 5) {
                return null;
            }
            return { level: n };
        }
        var m = s.match(/\bV\s*([1-5])\b/i);
        if (m) {
            return level_from_digit_char(m[1]);
        }
        var lone = s.match(/^\s*([1-5])\s*$/);
        if (lone) {
            return level_from_digit_char(lone[1]);
        }
        m = s.match(/(?:^|\s)([1-5])(?:\s*[-–])/);
        if (m) {
            return level_from_digit_char(m[1]);
        }
        return null;
    }

    function update_durability_scale_ui(durability_el, raw_label) {
        if (!durability_el) {
            return;
        }
        var scale = durability_el.querySelector('._pdp_durability_scale');
        if (!scale) {
            return;
        }
        var parsed = parse_durability_label(raw_label);
        var steps = scale.querySelectorAll('._pdp_durability_scale__step');
        var fallback_p = durability_el.querySelector('.pdp-figma-spec-item__durability-fallback');
        var fallback = durability_el.querySelector('._custom-variant-spec-value');
        if (parsed === null) {
            scale.classList.add('is-hidden');
            scale.setAttribute('aria-hidden', 'true');
            scale.removeAttribute('aria-label');
            steps.forEach(function (el) {
                el.classList.remove('is-active');
                var mark = el.querySelector('._pdp_durability_scale__mark');
                if (mark) {
                    mark.textContent = '';
                }
            });
            if (fallback_p) {
                domShow(fallback_p);
            } else if (fallback) {
                domShow(fallback);
            }
            return;
        }
        scale.classList.remove('is-hidden');
        scale.setAttribute('aria-hidden', 'false');
        scale.setAttribute('aria-label', 'Slidstyrke trin ' + String(parsed.level) + ' af 5');
        steps.forEach(function (el) {
            var step_n = parseInt(el.getAttribute('data-step'), 10);
            var mark = el.querySelector('._pdp_durability_scale__mark');
            if (step_n === parsed.level) {
                el.classList.add('is-active');
                if (mark) {
                    mark.textContent = String(parsed.level);
                }
            } else {
                el.classList.remove('is-active');
                if (mark) {
                    mark.textContent = '';
                }
            }
        });
        if (fallback_p) {
            domHide(fallback_p);
        } else if (fallback) {
            domHide(fallback);
        }
    }

    function update_color_shade_grid_span(has_durability) {
        document.querySelectorAll('#_custom-variant-spec-color-shade').forEach(function (color_shade_el) {
            if (has_durability) {
                color_shade_el.classList.remove('is-wide');
            } else {
                color_shade_el.classList.add('is-wide');
            }
        });
    }

    function update_spec_info(variant) {
        if (!variant || !variant.metafields) {
            return;
        }
        document.querySelectorAll('#_custom-variant-spec-frostproof').forEach(function (frostproof) {
            var frostVal = frostproof.querySelector('._custom-variant-spec-value');
            var frostIcon = frostproof.querySelector('.pdp-figma-spec-item__frost-icon');
            var fp = variant.metafields.frostproof;
            var isJa = fp === 'JA' || fp === 'Ja' || fp === 'ja';
            if (frostVal) {
                frostVal.innerHTML = isJa ? 'Ja' : 'Nej';
            }
            if (frostIcon) {
                if (isJa) {
                    frostIcon.removeAttribute('hidden');
                } else {
                    frostIcon.setAttribute('hidden', '');
                }
            }
        });
        document.querySelectorAll('#_custom-variant-spec-durability').forEach(function (durability) {
            if (variant.metafields.durability) {
                domShow(durability);
                var dval = durability.querySelector('._custom-variant-spec-value');
                if (dval) {
                    dval.innerHTML = variant.metafields.durability;
                }
                update_durability_scale_ui(durability, variant.metafields.durability);
            } else {
                domHide(durability);
                update_durability_scale_ui(durability, '');
            }
        });
        update_color_shade_grid_span(!!variant.metafields.durability);
        document.querySelectorAll('#_custom-variant-spec-thickness').forEach(function (thickness_el) {
            if (variant.metafields.thickness) {
                domShow(thickness_el);
                var tv = thickness_el.querySelector('._custom-variant-spec-value');
                if (tv) {
                    tv.innerHTML = variant.metafields.thickness;
                }
            } else {
                domHide(thickness_el);
            }
        });
        document.querySelectorAll('#_custom-variant-spec-color-shade').forEach(function (color_shade_el) {
            if (variant.metafields.color_shade) {
                domShow(color_shade_el);
                var cv = color_shade_el.querySelector('._custom-variant-spec-value');
                if (cv) {
                    cv.innerHTML = variant.metafields.color_shade;
                }
            } else {
                domHide(color_shade_el);
            }
        });
        var r_value = variant.metafields.r_value;
        var r_value_label = r_value == null ? '' : String(r_value).trim();
        document.querySelectorAll('#_custom-variant-spec-r-value').forEach(function (r_value_el) {
            var value_el = r_value_el.querySelector('._custom-variant-spec-value');
            if (value_el) {
                value_el.textContent = r_value_label;
            }
            r_value_el.hidden = r_value_label === '';
        });
        var has_specs = ['frostproof', 'durability', 'thickness', 'color_shade', 'r_value'].some(function (key) {
            var value = variant.metafields[key];
            return value != null && value !== false && String(value).trim() !== '';
        });
        document.querySelectorAll('.pdp-figma-specs').forEach(function (specs) {
            specs.hidden = !has_specs;
        });
    }

    function reset_plinth_swatches() {
        document.querySelectorAll('.product-option-item.pdp-figma-size-pill--plinth').forEach(function (label_el) {
            label_el.classList.remove('pdp-figma-size-pill--plinth');
        });
        document.querySelectorAll('.pdp-figma-size-pill__caption[data-default-caption]').forEach(function (caption_el) {
            caption_el.textContent = caption_el.dataset.defaultCaption || '';
        });
    }

    function variant_is_plinth_for_context(variant, current_color, current_surface) {
        if (!variant) {
            return false;
        }
        return !!(variant.metafields && variant.metafields.is_a_plinth === true)
            && String(variant.color) === String(current_color)
            && String(variant.surface) === String(current_surface);
    }

    function restore_plinth_size_pill_ui(option_el, label_el) {
        if (!option_el || !label_el) {
            return;
        }
        label_el.classList.remove('pdp-figma-size-pill--has-image', 'pdp-figma-size-pill--image-only', 'has-bg-img');
        label_el.classList.add('border', 'border-color-border');
        label_el.style.backgroundImage = '';
        label_el.style.backgroundSize = '';
        label_el.style.backgroundPosition = '';
        label_el.style.backgroundRepeat = '';
        label_el.setAttribute('aria-label', 'Sokkel');
        if (!label_el.querySelector('.pdp-figma-size-pill__glyph')) {
            var glyph_el = document.createElement('span');
            glyph_el.className = 'pdp-figma-size-pill__glyph';
            glyph_el.setAttribute('aria-hidden', 'true');
            label_el.appendChild(glyph_el);
        }
        var caption_el = option_el.querySelector('.pdp-figma-size-pill__caption');
        if (!caption_el) {
            caption_el = document.createElement('span');
            caption_el.className = 'pdp-figma-size-pill__caption';
            option_el.appendChild(caption_el);
        }
        caption_el.dataset.defaultCaption = 'Sokkel';
        caption_el.textContent = 'Sokkel';
        option_el.classList.remove('pdp-figma-size-option--image-only');
    }

    function update_plinth_swatch(variants, current_variant) {
        var active_variant = current_variant || resolveSelectedVariant() || getCurrentVariant();
        var current_color = active_variant ? (active_variant.color || '') : '';
        var current_surface = active_variant ? (active_variant.surface || '') : '';
        document.querySelectorAll('.pdp-figma-size-option').forEach(function (option_el) {
            var size_value = option_el.getAttribute('data-value');
            if (!size_value) {
                return;
            }
            var should_be_plinth = variants.some(function (variant) {
                return String(variant.size) === String(size_value) && variant_is_plinth_for_context(variant, current_color, current_surface);
            });
            var text_label_el = option_el.querySelector('label.pdp-size-text-option');
            if (text_label_el) {
                var size_label = text_label_el.getAttribute('data-size-label') || size_value;
                var next_label = size_label + (should_be_plinth && !/sokkel/i.test(size_label) ? ' (sokkel)' : '');
                if (text_label_el.textContent !== next_label) {
                    text_label_el.textContent = next_label;
                }
                return;
            }
            var label_el = option_el.querySelector('label.product-option-item.pdp-figma-size-pill');
            if (label_el) {
                label_el.classList.toggle('pdp-figma-size-pill--plinth', should_be_plinth);
                if (should_be_plinth) {
                    restore_plinth_size_pill_ui(option_el, label_el);
                }
            }
            var caption_el = option_el.querySelector('.pdp-figma-size-pill__caption[data-default-caption]');
            if (caption_el) {
                var next_caption = should_be_plinth ? 'Sokkel' : (caption_el.dataset.defaultCaption || '');
                if (caption_el.textContent !== next_caption) {
                    caption_el.textContent = next_caption;
                }
            }
        });
    }

    function get_sold_out_button_label(add_button) {
        if (add_button && add_button.getAttribute('data-atc-sold-out-text')) {
            return add_button.getAttribute('data-atc-sold-out-text');
        }
        return 'Udsolgt';
    }

    function get_default_atc_button_label(add_button) {
        if (add_button && add_button.getAttribute('data-atc-text')) {
            return add_button.getAttribute('data-atc-text');
        }
        if (global.MinimogStrings && global.MinimogStrings.addToCart) {
            return global.MinimogStrings.addToCart;
        }
        return 'Tilføj til kurven';
    }

    function set_atc_cart_icon_visible(add_button, is_visible) {
        if (!add_button) {
            return;
        }
        var cart_icon = add_button.querySelector('.pdp-atc-cart-icon');
        if (!cart_icon) {
            return;
        }
        if (is_visible) {
            if (cart_icon.style.removeProperty) {
                cart_icon.style.removeProperty('display');
            } else {
                cart_icon.style.removeAttribute('display');
            }
            return;
        }
        cart_icon.style.display = 'none';
    }

    function sync_buy_button_sold_out_state(add_button, is_sold_out) {
        if (!add_button) {
            return;
        }
        var atc_text_el = add_button.querySelector('.atc-text');
        if (is_sold_out) {
            add_button.disabled = true;
            add_button.setAttribute('disabled', 'disabled');
            add_button.setAttribute('aria-disabled', 'true');
            add_button.classList.add('disabled');
            if (atc_text_el) {
                atc_text_el.textContent = get_sold_out_button_label(add_button);
            }
            set_atc_cart_icon_visible(add_button, false);
            return;
        }
        add_button.disabled = false;
        add_button.removeAttribute('disabled');
        add_button.removeAttribute('aria-disabled');
        add_button.classList.remove('disabled');
        if (atc_text_el) {
            atc_text_el.textContent = get_default_atc_button_label(add_button);
        }
        set_atc_cart_icon_visible(add_button, true);
    }

    function sync_standard_buy_button_state(buyBlock, ob) {
        if (!buyBlock || !ob) {
            return;
        }
        var add_button = buyBlock.querySelector('.add-to-cart');
        var qty_wrapper = buyBlock.querySelector('.quantity_and_buy_button_div .form__input-wrapper');
        if (ob.fulfillment_state === 'special_order') {
            buyBlock.classList.add('orderability-hide-buy');
            if (add_button) {
                domHide(add_button);
            }
            if (qty_wrapper) {
                domHide(qty_wrapper);
            }
            return;
        }
        if (add_button) {
            domShow(add_button);
        }
        if (qty_wrapper) {
            domShow(qty_wrapper);
        }
        if (ob.hide_standard_buy_buttons) {
            buyBlock.classList.add('orderability-hide-buy');
            sync_buy_button_sold_out_state(add_button, true);
            return;
        }
        buyBlock.classList.remove('orderability-hide-buy');
        sync_buy_button_sold_out_state(add_button, false);
    }

    function sync_m2_figma_atc_state(figma_m2_atc, ob) {
        if (!figma_m2_atc || !ob || !ob.uses_m2_calculator) {
            return;
        }
        if (ob.fulfillment_state === 'special_order') {
            domHide(figma_m2_atc);
            figma_m2_atc.disabled = true;
            figma_m2_atc.setAttribute('disabled', 'disabled');
            figma_m2_atc.setAttribute('aria-disabled', 'true');
            figma_m2_atc.classList.add('disabled');
            return;
        }
        domShow(figma_m2_atc);
        sync_buy_button_sold_out_state(figma_m2_atc, !!ob.hide_standard_buy_buttons);
    }

    function wire_special_order_cart_block() {
        document.querySelectorAll('form.main-product-form, form[data-type="add-to-cart-form"]').forEach(function (form) {
            if (form.dataset.hfcSpecialOrderCartBlock) {
                return;
            }
            form.dataset.hfcSpecialOrderCartBlock = '1';
            form.addEventListener(
                'submit',
                function (ev) {
                    var root =
                        form.closest('[data-pdp-orderability-root]') ||
                        document.querySelector('[data-pdp-orderability-root]');
                    if (root && root.getAttribute('data-fulfillment-state') === 'special_order') {
                        ev.preventDefault();
                        ev.stopImmediatePropagation();
                    }
                },
                true
            );
        });
    }

    function applyOrderabilityToDom(variant) {
        var d = global.HFCProductDomain;
        var product = global.shopify_product || {};
        if (!variant) {
            variant = resolveSelectedVariant();
        }
        var ob = variant
            ? getOrderability(variant)
            : (d && typeof d.deriveOrderabilityView === 'function'
                ? d.deriveOrderabilityView(null, product)
                : resolveOrderabilityFallback(null));
        syncOrderabilityRootAttrs(ob);
        document.querySelectorAll('#m2_price_calculator.pdp-figma-m2-root .pdp-figma-m2-calc').forEach(function (calculator) {
            calculator.hidden = !!ob.hide_standard_buy_buttons;
        });
        sync_selected_media_state(variant);
        update_plinth_swatch(getProductVariants(), variant);
        var msg = document.querySelector('[data-orderability-unavailable-msg]');
        var buyBlock = document.querySelector('.main-product__block-buy_buttons');
        var figma_m2_atc = document.querySelector('#m2_price_calculator button.pdp-figma-m2-atc');
        if (!variant) {
            if (buyBlock) {
                buyBlock.style.display = 'none';
            }
            if (figma_m2_atc) {
                domHide(figma_m2_atc);
                figma_m2_atc.disabled = true;
                figma_m2_atc.setAttribute('disabled', '');
                figma_m2_atc.setAttribute('aria-disabled', 'true');
                figma_m2_atc.classList.add('disabled');
            }
            if (msg) {
                msg.textContent = 'Den valgte variant er ikke tilgængelig.';
                msg.classList.remove('hidden');
            }
            return;
        }
        var m2 = global.HFCProductPdpM2CalculatorUi;
        if (m2 && typeof m2.handleCalculatorMode === 'function') {
            m2.handleCalculatorMode(variant, getProductVariants());
        }
        if (ob.uses_m2_calculator) {
            apply_tile_m2_layout_from_orderability(variant, ob);
        }
        var soSection = document.querySelector('.main-product__block.main-product__block-special_order_product');
        var specInStock = document.querySelector('#special_order_product-enabled');
        var specStore = document.querySelector('#special_order_prod_available_on_storagefacility');
        var inventory_quantity = document.querySelector('#_custom-inventory-quantity');
        if (ob.fulfillment_state === 'special_order') {
            if (soSection) {
                domShow(soSection);
            }
            var qty = parseInt(variant.inventory_quantity, 10) || parseInt(variant.total_packs, 10) || 0;
            if (qty > 0) {
                if (specInStock) {
                    domShow(specInStock);
                }
                if (specStore) {
                    domHide(specStore);
                }
            } else {
                if (specInStock) {
                    domHide(specInStock);
                }
                if (specStore) {
                    domShow(specStore);
                }
            }
            if (inventory_quantity) {
                domHide(inventory_quantity);
            }
        } else {
            if (soSection) {
                domHide(soSection);
            }
            if (specInStock) {
                domHide(specInStock);
            }
            if (specStore) {
                domHide(specStore);
            }
            if (inventory_quantity && ob.fulfillment_state !== 'special_order') {
                if (inventory_quantity.style.removeProperty) {
                    inventory_quantity.style.removeProperty('display');
                } else {
                    inventory_quantity.style.removeAttribute('display');
                }
            }
        }
        if (buyBlock) {
            sync_standard_buy_button_state(buyBlock, ob);
            buyBlock.style.removeProperty('display');
        }
        sync_m2_figma_atc_state(figma_m2_atc, ob);
        if (ob.uses_m2_calculator && variant) {
            var m2_sync = global.HFCProductPdpM2CalculatorUi;
            if (m2_sync && typeof m2_sync.changeProductDetails === 'function') {
                m2_sync.changeProductDetails(variant);
            }
            if (m2_sync && typeof m2_sync.renderCalculation === 'function') {
                m2_sync.renderCalculation(variant);
            }
        }
        if (msg) {
            if (ob.hide_standard_buy_buttons) {
                msg.textContent = '';
                msg.classList.add('hidden');
            } else if (ob.primary_state === 'unavailable') {
                msg.textContent = 'Den valgte variant er ikke tilgængelig.';
                msg.classList.remove('hidden');
            } else {
                msg.textContent = '';
                msg.classList.add('hidden');
            }
        }
        syncBackorderBlockVisibility(variant, ob, null);
        update_inventory_info_from_variant(variant, ob);
        update_spec_info(variant);
        syncHfcLinePropertyInputs(variant, ob);
    }

    global.HFCProductPdpOrderabilityUi = {
        getOrderability: getOrderability,
        applyOrderabilityToDom: applyOrderabilityToDom,
        syncHfcLinePropertyInputs: syncHfcLinePropertyInputs,
        variantUsesM2Calculator: variantUsesM2Calculator,
        syncBackorderBlockVisibility: syncBackorderBlockVisibility,
        updatePlinthSwatch: update_plinth_swatch,
        domShow: domShow,
        domHide: domHide,
    };

    wire_special_order_cart_block();
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', wire_special_order_cart_block);
    }
})(typeof window !== 'undefined' ? window : this);
